import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { contentfulModels } from '@glowforge/ui-common';
import withCountryCode, { getValueFromCountryCode } from 'app/common/containers/country-code';
import { AnnouncementFragment, ReferralFragment } from './content-body';

import './message-banner.less';

const {
  getMarkdownStringsForWidget,
  widgetDefaultProps,
  widgetPropType,
} = contentfulModels;

/**
 * Homepage Message banner
 * Combines Announcement Banner and Referral Banner for Above The Fold A/B Test.
 * https://glowforge.atlassian.net/wiki/spaces/UD/pages/1064501566/Above+the+Fold
 */
class MessageBanner extends React.PureComponent {
  render() {
    const { countryCode, referralInfo, products, model } = this.props;

    const strings = getMarkdownStringsForWidget(this.props);
    const showReferralInfo = _.get(referralInfo, 'showReferralInfo');
    const isAffiliate = _.get(referralInfo, 'isAffiliate');
    const announcement = getValueFromCountryCode('homepage-announcement', countryCode, strings);

    let body;
    // Wait until all data necessary is available for referral
    if (showReferralInfo && referralInfo && !_.isEmpty(products)) {
      body = (
        <ReferralFragment
          isAffiliate={isAffiliate}
          strings={strings}
          referralInfo={referralInfo}
          products={products} />
      );
    } else if (announcement) {
      body = (
        <AnnouncementFragment
          announcement={announcement}
          countryCode={countryCode}
          sections={_.get(model, 'widgetData.fields.sections')} />
      );
    } else {
      // If neither a referral or announcement exists, render nothing.
      return null;
    }

    const className = classnames('MessageBanner', 'fullWidth', 'noMarginTop', 'noMarginBottom');
    return (
      <div className={className}>
        <div className='content-wrapper'>
          {body}
        </div>
      </div>
    );
  }
}
MessageBanner.propTypes = { ...widgetPropType };

MessageBanner.defaultProps = { ...widgetDefaultProps };

export default withCountryCode(MessageBanner);




// WEBPACK FOOTER //
// ./app/components/landing/message-banner/message-banner.jsx